import { Vue } from 'vue-property-decorator';

import {
   formatterDate,
   formatterTime,
   formatterFloat,
   formatterNumber,
   formatDate,
   formatTime,
   parseFloatCustom,
   parseIntCustom,
   customFormatter,
} from '@/config/functions';

import { mapValues } from 'lodash';

const currencies = mapValues(require('currency-formatter/currencies.json'), (c: any) => ({
   ...c,
   symbolPosition: c.symbolOnLeft ? 'front' : '',
   fractionCount: c.decimalDigits,
}));

export default class BasePage extends Vue {
   customFormatter: object = customFormatter;

   formatterFloat = formatterFloat;

   formatterNumber = formatterNumber;

   formatterTime = formatterTime;

   formatterDate = formatterDate;

   formatDate = formatDate;

   formatTime = formatTime;

   parseFloatCustom = parseFloatCustom;

   parseIntCustom = parseIntCustom;

   currencies!: any[];

   currencyParams: any = currencies['EUR'];

   showMessage(innerHTML: string, params: any = {}) {
      const h = this.$createElement;

      const description = h('div', {
         class: ['modal-scrollable'],
         domProps: { innerHTML },
      });

      return this.$bvModal.msgBoxOk([description], {
         'ok-title': this.$t('buttons.ok'),
         ...params,
      });
   }
}
